<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!--begin::Form-->
    <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }}
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <div class="form-group">  
                <label class="label-required" >ประเภทตัวแทนจำหน่าย: </label>
                <div class="row">
                  <div
                    class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-1"
                  ></div>
                  <div
                    class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-xs-11"
                  >
                    <div class="kt-radio-inline"> 
              
                      <label class="kt-radio"  v-show="IS_RADIO_SHOW_AGENT">
                        <input
                          type="radio"
                          id="epmrAgentTypeCode"
                          name="AGENT_TYPE_CODE"
                          value="AGENT"
                          v-model="epmrAgentTypeCode"
                          ref="epmrAgentTypeCode" 
                            @change="onEpmrAgentTypeCodeChange(this)"
                           
                        />
                        <span></span>
                        ตัวแทนจำหน่าย
                      </label>
                      <label class="kt-radio" v-show="IS_RADIO_SHOW_SUB_AGENT"> 
                        <input
                          type="radio"
                          id="epmrAgentTypeCode"
                          name="AGENT_TYPE_CODE"
                          value="SUB_AGENT"
                          v-model="epmrAgentTypeCode"
                          ref="epmrAgentTypeCode" 
                            @change="onEpmrAgentTypeCodeChange(this)"
                             
                        />
                        <span></span>
                        ตัวแทนจำหน่ายย่อย
                      </label>
                       
                    </div>
                  </div>
                </div>
              </div> 
            </div>

            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-3">
              <div class="form-group">
                <label class="label-required">ประเภท:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control'"
                  :id="'epmrTypeCode'"
                  :name="'epmrTypeCode'"
                  :select2-options="epmrTypeCodeOptions"
                  v-model="epmrTypeCode"
                  ref="epmrTypeCodeSelect2"
                  @selectChange="onEpmrTypeCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">วันที่:</label>
                <div class="input-group date">
                  <input
                    readonly
                    :disabled="isEdit"
                    type="text"
                    class="form-control"
                    placeholder="(วว/ดด/ปปปป)"
                    id="epmrDate"
                    name="epmrDate"
                    ref="epmrDate"
                    @click="onDateClick"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">
                      <i class="la la-calendar-check-o"></i>
                    </span>
                  </div>
                  <span class="form-text"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-show="epmrAgentTypeCode=='AGENT'">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่าย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'epmrAgentCode'"
                  :name="'epmrAgentCode'"
                  :select2-options="epmrAgentCodeOptions"
                  v-model="epmrAgentCode"
                  ref="epmrAgentCodeSelect2"
                  @selectChange="onEpmrAgentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ร้านค้า:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'epmrShopCodes'"
                  :name="'epmrShopCodes'"
                  :select2-options="epmrShopCodesOptions"
                  v-model="epmrShopCodes"
                  ref="epmrShopCodesSelect2"
                  multiple
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!---sub agent-->
          <div class="row" v-show="epmrAgentTypeCode=='SUB_AGENT'">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ตัวแทนจำหน่ายย่อย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'epmrSubAgentCode'"
                  :name="'epmrSubAgentCode'"
                  :select2-options="epmrSubAgentCodeOptions"
                  v-model="epmrSubAgentCode"
                  ref="epmrSubAgentCodeSelect2"
                  @selectChange="onEpmrSubAgentCodeChange"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ร้านค้าตัวแทนจำหน่ายย่อย:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'epmrSubShopCodes'"
                  :name="'epmrSubShopCodes'"
                  :select2-options="epmrSubShopCodesOptions"
                  v-model="epmrSubShopCodes"
                  ref="epmrSubShopCodesSelect2"
                  multiple
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <!-- end sub agent -->
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ชื่อรูท:</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="ชื่อรูท"
                  id="epmrRouteName"
                  name="epmrRouteName"
                  ref="epmrRouteName"
                  v-model="epmrRouteName"
                />
                <span class="form-text"></span>
              </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <div class="form-group">
                <label class="label-required">ผู้ดำเนินการ:</label>
                <select2
                  :css-style="'width: 100%;'"
                  :css-class="'form-control m-select2'"
                  :id="'epmrPmUserId'"
                  :name="'epmrPmUserId'"
                  :select2-options="epmrPmUserIdOptions"
                  v-model="epmrPmUserId"
                  ref="epmrPmUserIdSelect2"
                ></select2>
                <span class="form-text"></span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
              <div class="form-group">
                <label>สถานะ:</label>
                <div class="form-check">
                  <label class="form-check-label kt-checkbox">
                    <input type="checkbox" class="form-check-input" name="epmrInActiveStatus" id="epmrInActiveStatus" v-model="epmrInActiveStatus" />
                    เปิดใช้งาน
                    <span></span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="kt-portlet__foot">
        <button type="button" class="btn btn-secondary" @click="$router.go(-1)"><i class="la la-close"></i> ย้อนกลับ</button>
        <button type="submit" class="btn btn-primary"><i class="la la-save"></i> บันทึกข้อมูล</button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import select2 from "../../Shared/Select2";
import datepicker from "../../Shared/Datepicker";

export default {
  components: {
    select2,
    datepicker,
  },
  data: function() {
    var self = this;

    var is_super_admin = self.$root.canShow(["super_admin"]) || self.$root.canShow(["ADMIN_PM"])  ;
    var is_agent_admin_pm = self.$root.canShow(["AGENT_ADMIN_PM"])  ;
    var is_sub_agent_admin_pm = self.$root.canShow(["SUB_AGENT_ADMIN_PM"])  ; 
 

    return {
      epmrPMRoutePlanId: null,
      epmrTypeCode: null,
      epmrDate: null,
      epmrAgentCode: null,
      epmrShopCodes: [],
      epmrRouteName: null,
      epmrPmUserId: null,
      epmrInActiveStatus: null,
      isEdit: false,
 
      epmrSubAgentCode : null, 
      epmrSubShopCodes : [],  
      epmrAgentTypeCode : is_agent_admin_pm ?  "AGENT"  :   "SUB_AGENT", 
      IS_RADIO_SHOW_AGENT : (is_agent_admin_pm || is_super_admin) ? true :  false ,
      IS_RADIO_SHOW_SUB_AGENT : (is_super_admin || is_sub_agent_admin_pm) ? true : false, 

      // Configurations
      epmrTypeCodeOptions: {
        placeholder: "กรุณาเลือกประเภท",
        allowClear: false,
        ajax: {
          delay: 300,
          url: "/Api/Variables/Options",
          data: function(params) {
            var query = {
              search: "PM_TYPE",
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      epmrAgentCodeOptions: {
        placeholder: "กรุณาเลือกตัวแทนจำหน่าย",
        allowClear: true,
        ajax: {
          url: self.$root.canShow(["AGENT_ADMIN_PM"]) ? "/Api/Agents/AgentOptions" : "/Api/Agents/Select2Agent?companyType=COMPANY_PROFILE_TYPE_PM",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              agentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      epmrShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Shop/Select2ShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      epmrSubShopCodesOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
         
        ajax: {
          url: "/Api/Shop/SubShopOptionAlertReport",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = { 
              agentCodes : self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              shopCodes  : self.epmrSubAgentCode != null ? [self.epmrSubAgentCode] : null,
              search: params.term,
              page: params.page || 1,
              all: true,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      }, 
      epmrSubAgentCodeOptions: {
        placeholder: "กรุณาเลือก",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2SubShopAgent",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              agentCodes: null,//self.apmrAgentCode != null ? [self.apmrAgentCode] : null,
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },   
      epmrPmUserIdOptions: {
        placeholder: "กรุณาเลือกผู้ดำเนินการ",
        allowClear: true,
        ajax: {
          url: "/Api/PM/Select2PmUser",
          type: "post",
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              //agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              agentTypeCode  : self.epmrAgentTypeCode ,
              agentCodes: self.epmrAgentCode != null ? [self.epmrAgentCode] : null,
              subAgentCodes: self.epmrSubAgentCode != null ? [self.epmrSubAgentCode] : null,
              IS_SUPER_ADMIN :  self.$root.canShow(["super_admin"]),
              IS_AGENT_ADMIN_PM : self.$root.canShowExSuperAdmin(["AGENT_ADMIN_PM"]),
              IS_SUB_AGENT_ADMIN_PM : self.$root.canShowExSuperAdmin(["SUB_AGENT_ADMIN_PM"]), 
              search: params.term,
              page: params.page || 1,
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader("Authorization", "Bearer " + self.$root.user.access_token);
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
    };
  },
  methods: {
    formSubmit: function(e) {
      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังบันทึกข้อมูล กรุณารอสักครู่...",
      });

      let router = this.$router;
      let self = this;

      axios
        .put("/Api/PM/RoutePlan/Edit", {
          PMRoutePlanId: this.epmrPMRoutePlanId,
          AgentCode: this.epmrAgentCode,
          TypeCode: this.epmrTypeCode,
          RoutePlanDate: this.epmrDate.format("DD/MM/YYYY"),
          ShopCodes: this.epmrShopCodes,
          RouteName: this.epmrRouteName,
          PmUserId: this.epmrPmUserId,
          InActiveStatus: !this.epmrInActiveStatus,

          SubAgentCode: this.epmrSubAgentCode,
          SubAgentShopCodes: this.epmrSubShopCodes,
          AgentTypeCode: this.epmrAgentTypeCode, 
        })
        .then(function(response) {
          console.log(response);
          if (response.data.status) {
            KTApp.unblockPage();
            Swal.fire("สำเร็จ", response.data.message, "success").then(function() {
              router.go(-1), self.$parent.reloadDataTable(false);
            });
          } else {
            Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", response.data.message, "error");
        })
        .then(function() {
          // always executed
          KTApp.unblockPage();
        });
    },
    onEpmrTypeCodeChange: function(id, text, data, ref) {
      var self = this;
      if (text != "") {
        if (text == "PM_TYPE_ADHOC") {
          self.epmrDate = moment();
          self.isEdit = true;
        } else if (text == "PM_TYPE_ROUTE_PLAN") {
          self.epmrDate = moment().add(1, "days");
          self.isEdit = false;
        }

        $(self.$refs.epmrDate)
          .datepicker("update", !!self.epmrDate ? self.epmrDate.format("DD/MM/YYYY") : null)
          .on("changeDate", function(e) {
            self.epmrDate = e.dates.length != 0 ? moment(e.date) : null;
          });
      }
    },
    onEpmrAgentCodeChange() {
      this.epmrShopCodes = [];

      $("#epmrShopCodes")
        .val("")
        .trigger("change");

      this.epmrPmUserId = null;

      $("#epmrPmUserId")
        .val("")
        .trigger("change");

      //   this.epmrSubAgentCode = []; 
      // $("#epmrSubAgentCode")
      // .val("")
      // .trigger("change");
    },
    onEpmrAgentTypeCodeChange : function(obj){
     
     var self = this; 
     
     this.epmrAgentCode = null; 
     $("#epmrAgentCode")
     .val("")
     .trigger("change"); 

     this.epmrShopCodes = [];  
     $("#epmrShopCodes")
       .val("")
       .trigger("change");  


     this.epmrSubAgentCode = []; 
     $("#epmrSubAgentCode")
     .val("")
     .trigger("change");

     this.epmrSubShopCodes = null; 
     $("#epmrSubShopCodes")
     .val("")
     .trigger("change"); 
       
   },
   onEpmrSubAgentCodeChange: function(id, text, data, ref) {  
      var self = this;  
      if(data[0]!=undefined){ 
        this.epmrAgentCode = data[0].data ;
      } 
      // this.epmrShopCodes = [];  
      // $("#epmrShopCodes")
      //   .val("")
      //   .trigger("change"); 

      this.epmrPmUserId = null; 
      $("#epmrPmUserId")
        .val("")
        .trigger("change"); 

        this.epmrSubShopCodes = []; 
      $("#epmrSubShopCodes")
      .val("")
      .trigger("change");
    },
    onDateClick() {
      let self = this;
      let epmrDate = self.epmrDate;
      if (epmrDate != null) {
        let today = moment();
        let startDate = today < epmrDate ? today : epmrDate;
        $(self.$refs.epmrDate).datepicker("setStartDate", startDate.format("DD/MM/YYYY"));
      } else {
        $(self.$refs.epmrDate).datepicker("setStartDate", moment().format("DD/MM/YYYY"));
      }
    },
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }

    $(self.$refs.epmrDate).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    $(self.$refs.epmrDate)
      .datepicker("update", !!self.epmrDate ? self.epmrDate.format("DD/MM/YYYY") : null)
      .on("changeDate", function(e) {
        self.epmrDate = e.dates.length != 0 ? moment(e.date) : null;
      });

    // set validation rules
    $(this.$refs.form).validate({
      rules: {
        epmrTypeCode: "required",
        epmrDate: "required",
        epmrAgentCode: "required",
        epmrShopCodes: "required",
        epmrRouteName: "required",
        epmrPmUserId: "required",
        epmrSubAgentCode: "required",
        epmrSubShopCodes: "required",
      },
      messages: {
        epmrTypeCode: "กรุณาเลือกประเภท",
        epmrDate: "กรุณาเลือกวันที่",
        epmrAgentCode: "กรุณาเลือกตัวแทนจำหน่าย",
        epmrShopCodes: "กรุณาเลือกประเภทร้านค้า",
        epmrSubAgentCode: "กรุณาเลือกตัวแทนจำหน่ายย่อย",
        epmrSubShopCodes: "กรุณาเลือกร้านค้า",
        epmrRouteName: "กรุณากรอกชื่อรูท",
        epmrPmUserId: "กรุณาเลือกผู้ดำเนินการ",
        
      },
    });

    $(this.$refs.form).validate().settings.ignore = ":hidden";

    axios
      .get("/Api/PM/RoutePlan/" + this.$route.params.id)
      .then(function(response) {
        console.log(response);
        if (response.status == 200) {
          self.epmrPMRoutePlanId = response.data.pmRoutePlanId;
          self.epmrInActiveStatus = !response.data.inActiveStatus;
          self.epmrRouteName = response.data.routeName;

           
          //self.epmrSubAgentCode = response.data.subAgentCode;
          //self.epmrSubShopCodes = response.data.routeName;
          self.epmrAgentTypeCode = response.data.agentTypeCode;
          
          

          if (response.data.typeCode) {
            self.$refs.epmrTypeCodeSelect2.setSelectedData({
              id: response.data.typeCode,
              text: response.data.typeName,
            });
          }

          setTimeout(function() {  
            self.epmrAgentCode = response.data.agentCode ; 
          }, 100);
 
          if (response.data.subAgentCode) { 
            self.$refs.epmrSubAgentCodeSelect2.setSelectedData({
              id: response.data.subAgentCode,
              text: "["+response.data.subAgentCustCode+"] "+ response.data.subAgentName + " ("+response.data.agentName+")",
            });
          } 
          setTimeout(function() {
            // console.log('-------x-----');
            // console.log(response.data);
            // console.log(obj);

            if (response.data.pmRoutePlanShops) {
              var subAgentShopOptions = $.map(response.data.pmRoutePlanShops, function(obj, idx) {
                return {
                  id: obj.subAgentShopCode,
                  text: obj.subAgentShopName,
                };
              });
              self.$refs.epmrSubShopCodesSelect2.setSelectedData(subAgentShopOptions);
            }
 
          }, 100);
          ///

          if (response.data.agentCode) {
            self.$refs.epmrAgentCodeSelect2.setSelectedData({
              id: response.data.agentCode,
              text: response.data.agentName,
            });
          }

          setTimeout(function() {
            if (response.data.pmRoutePlanShops) {
              var shopOptions = $.map(response.data.pmRoutePlanShops, function(obj, idx) {
                return {
                  id: obj.shopCode,
                  text: obj.shopName,
                };
              });
              self.$refs.epmrShopCodesSelect2.setSelectedData(shopOptions);
            }

            if (response.data.pmUserId) {
              self.$refs.epmrPmUserIdSelect2.setSelectedData({
                id: response.data.pmUserId,
                text: response.data.pmUserName,
              });
            }

            self.epmrDate = moment(response.data.routePlanDateFormat, "DD/MM/YYYY");
            $(self.$refs.epmrDate).datepicker("update", response.data.routePlanDateFormat2);

            
            
          }, 100);
        } else {
          Swal.fire("เกิดข้อผิดพลาด", "ไม่พบข้อมูล Route Plan/Adhoc ที่คุณเลือก", "warning");
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire("เกิดข้อผิดพลาด", "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูล Route Plan/Adhoc ได้ในขณะนี้", "error");
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/PM/EditPMRoutePlan.vue